import { t } from '@lingui/core/macro';
import { ErrorPage } from 'noddi-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';

interface TireOfferErrorComponentProps {
  title: string;
  description: string;
}

export const TireOfferErrorComponent = ({ title, description }: TireOfferErrorComponentProps) => {
  const { brandEmail } = useCurrentBrand();
  return (
    <ErrorPage
      title={title}
      description={t`Please try again. If the problem persists, don't hesitate to reach out to us at ${brandEmail}`}
      logInput={{
        value: description,
        severity: 'error'
      }}
    />
  );
};
